import { render } from "./ModalAccessDcSuccess.vue?vue&type=template&id=10ca424e"
import script from "./ModalAccessDcSuccess.vue?vue&type=script&lang=js"
export * from "./ModalAccessDcSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__